import React, { useState, useEffect, useContext } from "react";
import {
  createItem,
  updateItem,
  getItemCategory,
  getSuppliers,
  getWarehouses,
  getUnits,
  getBrand,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import { WarehouseContext } from '../../../Utility/UserContext';
import { warehouse_id, shop_id } from "../../../Utility/function";

const ItemForm = ({ selectedProduct, closeModal, refreshList }) => {
  const ware_data = warehouse_id;
  const { showLoader, hideLoader, shopItem } = useContext(WarehouseContext);
  const [formData, setFormData] = useState({
    item_name: "",
    cat_id: "",
    brand_id: "",
    status: "1",
    units: "",
    descriptions: "",
    item_code: "",
    shop_id: shopItem?.shop_id || shop_id,
  });

  const [category, setCategory] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [brandsList, setBrandsList] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCategory();
    fetchUnits();
    fetchBrands();
    if (selectedProduct?.id) {
      setFormData({
        item_name: selectedProduct?.item_name || "",
        cat_id: selectedProduct?.cat_id || "",
        brand_id: selectedProduct?.brand_id || "",
        status: selectedProduct?.status?.toString() || "1",
        units: selectedProduct?.units || "",
        descriptions: selectedProduct?.descriptions || "",
        item_code: selectedProduct?.item_code || "",
        shop_id: selectedProduct?.shop_id || shopItem?.shop_id || shop_id,
      });
    }
  }, [selectedProduct, category.length]);

  const fetchBrands = async () => {
    try {
      const response = await getBrand();
      if (response.data && response.data.data) {
        setBrandsList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching brands data:", error);
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        const filtered = response.data.data.filter(u => {
          const title = (u.title || "").toLowerCase().trim();
          return title === "li" || title === "ml" || title === "litre" || title === "millilitre";
        });
        setUnitsList(filtered);
      }
    } catch (error) {
      console.error("Error fetching units data:", error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await getItemCategory();
      if (response.data && response.data.data) {
        const cate = response.data.data;
        setCategory(cate.filter(cat => cat.status == null || cat.status == 0));
      }
    } catch (error) {
      console.error("Error fetching category data:", error);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    showLoader();
    e.preventDefault();
    const validationErrors = {};

    if (!formData.item_name) {
      validationErrors.item_name = "Title is required.";
    }
    if (!formData.cat_id) {
      validationErrors.cat_id = "Category is required.";
    }
    if (!formData.units) {
      validationErrors.units = "Unit is required.";
    }

    if (Object.keys(validationErrors).length > 0) {
      hideLoader();
      setErrors(validationErrors);
      return;
    }

    const payload = {
      item_name: formData.item_name,
      cat_id: formData.cat_id,
      brand_id: formData.brand_id || null,
      units: formData.units,
      descriptions: formData.descriptions || "",
      item_code: formData.item_code || "",
      status: formData.status,
      shop_id: formData.shop_id,
    };

    try {
      if (selectedProduct?.id) {
        await updateItem(selectedProduct.id, payload);
        hideLoader();
        toast.success("Item updated successfully");
      } else {
        await createItem(payload);
        hideLoader();
        toast.success("Item added successfully");
      }
      closeModal();
      refreshList();
    } catch (error) {
      console.error("Error saving item data:", error);
      hideLoader();
      if (error.response && error.response.data) {
        toast.error(error.response.data.message || "Error saving item");
      } else {
        toast.error("Error saving item");
      }
    }
  };



  return (
    <div
      className="modal fade show"
      style={{ display: "block" }}
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header border-0">
            <h5 className="modal-title" style={{ fontFamily: "poppins" }}>
              {selectedProduct?.id ? "Edit Item" : "Add Item"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
          <div className="modal-body" style={{ fontFamily: "poppins" }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Category</label>
                <div className="col-8">
                  <select
                    name="cat_id"
                    value={formData.cat_id}
                    onChange={handleChange}
                    className="form-control text-normal"
                  >
                    <option value="">Select Category</option>
                    {category.map((item) => (
                      <option key={item.id} value={String(item.id)}>
                        {item.categories}
                      </option>
                    ))}
                  </select>
                  {errors.cat_id && (
                    <small className="text-danger">{errors.cat_id}</small>
                  )}
                </div>
              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Brand</label>
                <div className="col-8">
                  <select
                    name="brand_id"
                    value={formData.brand_id}
                    onChange={handleChange}
                    className="form-control text-normal"
                  >
                    <option value="">Select Brand (Optional)</option>
                    {brandsList.map((item) => (
                      <option key={item.brand_id} value={String(item.brand_id)}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Unit</label>
                <div className="col-8">
                  <select
                    name="units"
                    value={formData.units}
                    onChange={handleChange}
                    className="form-control text-normal"
                  >
                    <option value="">Select Unit</option>
                    {unitsList.map((item) => (
                      <option key={item.id} value={String(item.id)}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                  {errors.units && (
                    <small className="text-danger">{errors.units}</small>
                  )}
                </div>
              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Title <span className="text-danger">*</span></label>
                <div className="col-8">
                  <input
                    type="text"
                    name="item_name"
                    value={formData.item_name}
                    onChange={handleChange}
                    className="form-control text-normal"
                  />
                  {errors.item_name && (
                    <small className="text-danger">{errors.item_name}</small>
                  )}
                </div>
              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Product Code</label>
                <div className="col-8">
                  <input
                    type="text"
                    name="item_code"
                    value={formData.item_code}
                    onChange={handleChange}
                    className="form-control text-normal"
                    placeholder="Auto-generated if left blank"
                  />
                </div>
              </div>

              <div className="form-group mb-3 d-flex align-items-center">
                <label className="col-4 text-normal">Description</label>
                <div className="col-8">
                  <textarea
                    name="descriptions"
                    value={formData.descriptions}
                    onChange={handleChange}
                    className="form-control text-normal"
                    rows="3"
                    placeholder="Enter item description"
                  />
                </div>
              </div>



              <div className="mt-5">
                <button type="submit" className="btn btn-success float-end text-normal rounded-1">
                  {selectedProduct?.id ? "Update Item" : "Add Item"}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary ml-2 float-end me-1 text-normal rounded-1"
                  onClick={closeModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemForm;
